import { client, formatQueryParams } from 'util/sdk';

export default ({ fspId, id, ...params }) =>
  client
    .fsps(fspId)
    .payerAuditLogs.query(formatQueryParams({ payerId: id, ...params }));
